export const CV = {
  href: '/Khadija_Hammoud_CV_2026.pdf',
  fileName: 'Khadija_Hammoud_CV_2026.pdf',
};
